import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock, KeyRound, Mail, Link2 } from "lucide-react";
import { api, PF_TOKEN_KEY } from "../../lib/api";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { LogoMark } from "../Logo";
import axios from "axios";

const PF_API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const errText = (e, d) => { const x = e?.response?.data?.detail; return typeof x === "string" ? x : d; };

export const PfLogin = ({ onIn }) => {
  const [phone, setPhone] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api.pfLogin(phone.trim(), pw); localStorage.setItem(PF_TOKEN_KEY, r.token); onIn(); }
    catch (er) { toast.error(errText(er, "تعذّر تسجيل الدخول")); } finally { setBusy(false); }
  };
  return (
    <div dir="rtl" className="grid min-h-screen place-items-center bg-[#0E1A2B] px-4 font-body" data-testid="pf-login-page">
      {forgot ? <PfForgot initialPhone={phone} onDone={() => setForgot(false)} /> :
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl">
        <div className="mb-6 flex items-center gap-3"><LogoMark className="h-11 w-11" />
          <div><p className="font-heading text-xl font-extrabold text-slate-900">WorkZone</p><p className="text-xs text-slate-500">دخول مالك المنصة</p></div></div>
        <Label className="text-xs">رقم الجوال</Label>
        <Input value={phone} onChange={(e) => setPhone(e.target.value)} dir="ltr" inputMode="tel" placeholder="05xxxxxxxx" className="mb-3 mt-1" data-testid="pf-login-phone" />
        <Label className="text-xs">كلمة المرور</Label>
        <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} dir="ltr" className="mb-5 mt-1" data-testid="pf-login-password" />
        <Button type="submit" disabled={busy || !phone || !pw} className="w-full gap-2 rounded-xl bg-[#0E1A2B] hover:bg-[#1a2a42]" data-testid="pf-login-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} دخول</Button>
        <button type="button" onClick={() => setForgot(true)} className="mt-3 w-full text-center text-xs font-semibold text-blue-600 hover:underline" data-testid="pf-forgot-link">نسيت كلمة المرور؟</button>
        <p className="mt-4 text-center text-[11px] text-slate-400">هذه البوابة مستقلة عن حسابات الشركات</p>
      </form>}
    </div>
  );
};

const PfForgot = ({ initialPhone, onDone }) => {
  const [f, setF] = useState({ phone: initialPhone || "", code: "", n1: "" });
  const [sent, setSent] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const r = await axios.post(`${PF_API}/platform-auth/forgot`, { phone: f.phone.trim() }); setSent(r.data.channels?.join(" و ") || "رقم الجوال المسجّل"); }
    catch (e) { toast.error(errText(e, "تعذّر الإرسال")); } finally { setBusy(false); }
  };
  const reset = async () => {
    if (!/^\d{6}$/.test(f.n1)) { toast.error("الرمز السري يجب أن يكون 6 أرقام بالضبط"); return; }
    setBusy(true);
    try { await axios.post(`${PF_API}/platform-auth/reset`, { phone: f.phone.trim(), code: f.code.trim(), new_password: f.n1 }); toast.success("تم تغيير كلمة المرور — سجّل دخولك"); onDone(); }
    catch (e) { toast.error(errText(e, "تعذّر التغيير")); } finally { setBusy(false); }
  };
  return (
    <div className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl" data-testid="pf-forgot-card">
      <p className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-slate-900"><KeyRound className="h-5 w-5 text-amber-500" /> استعادة كلمة المرور</p>
      <Label className="text-xs">رقم الجوال</Label>
      <Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} dir="ltr" inputMode="tel" className="mb-3 mt-1" data-testid="pf-forgot-phone" />
      {!sent ? (
        <Button onClick={send} disabled={busy || !f.phone} className="w-full gap-2 rounded-xl bg-[#0E1A2B]" data-testid="pf-forgot-send">{busy && <Loader2 className="h-4 w-4 animate-spin" />} أرسل رمز الاستعادة</Button>
      ) : (<>
        <p className="mb-3 rounded-lg bg-emerald-50 p-2 text-xs text-emerald-700" data-testid="pf-forgot-sent">أرسلنا الرمز إلى {sent}</p>
        <Label className="text-xs">الرمز (6 أرقام)</Label>
        <Input value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} dir="ltr" inputMode="numeric" maxLength={6} className="mb-3 mt-1" data-testid="pf-forgot-code" />
        <Label className="text-xs">كلمة المرور الجديدة</Label>
        <Input pin value={f.n1} onChange={(e) => setF({ ...f, n1: e.target.value })} dir="ltr" className="mb-4 mt-1" data-testid="pf-forgot-new" />
        <Button onClick={reset} disabled={busy || f.code.length < 6 || !f.n1} className="w-full gap-2 rounded-xl bg-[#0E1A2B]" data-testid="pf-forgot-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ كلمة المرور</Button>
      </>)}
      <button type="button" onClick={onDone} className="mt-3 w-full text-center text-xs text-slate-500 hover:underline" data-testid="pf-forgot-back">رجوع لتسجيل الدخول</button>
    </div>
  );
};

export const PfRecoveryEmailCard = () => {
  const [f, setF] = useState({ email: "", pw: "" });
  const [def, setDef] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${PF_API}/platform-auth/recovery-email`).then((r) => { setF((p) => ({ ...p, email: r.data.email })); setDef(r.data.default_masked); }).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { await axios.post(`${PF_API}/platform-auth/recovery-email`, { email: f.email.trim(), current_password: f.pw }); toast.success(f.email.trim() ? "تم حفظ بريد الاستعادة" : "تم الرجوع للبريد الرئيسي"); setF((p) => ({ ...p, pw: "" })); }
    catch (e) { toast.error(errText(e, "تعذّر الحفظ")); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl bg-white p-5 sm:p-6" data-testid="pf-recovery-card">
      <p className="mb-1 flex items-center gap-2 font-heading font-bold text-slate-900"><Mail className="h-4 w-4 text-blue-500" /> بريد استعادة كلمة المرور</p>
      <p className="mb-4 text-xs text-slate-500">يوصل عليه رمز «نسيت كلمة المرور» مع الواتساب.{!f.email && def ? <> حالياً يُستخدم البريد الرئيسي <span dir="ltr" className="font-mono">{def}</span>.</> : ""} اتركه فارغاً للرجوع للبريد الرئيسي.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        <div><Label className="text-xs">بريد الاستعادة</Label><Input type="email" dir="ltr" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="name@example.com" className="mt-1" data-testid="pf-recovery-email" /></div>
        <div><Label className="text-xs">كلمة المرور الحالية (للتأكيد)</Label><Input type="password" dir="ltr" value={f.pw} onChange={(e) => setF({ ...f, pw: e.target.value })} className="mt-1" data-testid="pf-recovery-pw" /></div>
      </div>
      <Button onClick={save} disabled={busy || !f.pw} className="mt-4 gap-1.5 rounded-xl" data-testid="pf-recovery-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ البريد</Button>
    </div>
  );
};

export const PfLinkCard = () => {
  const [linked, setLinked] = useState(undefined);
  const [f, setF] = useState({ phone: "", pw: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.pfLinkGet().then((r) => setLinked(r.linked)).catch(() => setLinked(null));
  useEffect(() => { load(); }, []);
  const link = async () => {
    if (!window.confirm("بعد الربط يُحذف رقم دخول المنصة الحالي، وتدخل للمنصة برقم وكلمة مرور حساب الشركة. متابعة؟")) return;
    setBusy(true);
    try { await api.pfLink(f.phone, f.pw); toast.success("تم الربط"); setF({ phone: "", pw: "" }); load(); }
    catch (e) { toast.error(errText(e, "تعذّر الربط")); } finally { setBusy(false); }
  };
  const unlink = async () => {
    if (!window.confirm("فك الربط يعيد رقم دخول المنصة السابق. متابعة؟")) return;
    try { await api.pfUnlink(); toast.success("تم فك الربط"); load(); } catch (e) { toast.error(errText(e, "تعذّر فك الربط")); }
  };
  if (linked === undefined) return null;
  return (
    <div className="rounded-2xl bg-white p-5 sm:p-6" data-testid="pf-link-card">
      <p className="mb-1 flex items-center gap-2 font-heading font-bold text-slate-900"><Link2 className="h-4 w-4 text-emerald-600" /> ربط حساب شركة بلوحة المنصة</p>
      <p className="mb-4 text-xs text-slate-500">تدخل برقم حساب الشركة وتتنقل بين الشركة ولوحة المنصة بضغطة، بدون تسجيل دخول جديد.</p>
      {linked ? (
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl bg-emerald-50 p-3 text-sm" data-testid="pf-link-status">
          <span>مربوط بـ <b>{linked.name}</b> · <span dir="ltr">{linked.phone}</span>{linked.org_name ? ` · ${linked.org_name}` : ""}</span>
          <Button variant="outline" size="sm" onClick={unlink} data-testid="pf-unlink-btn">فك الربط</Button>
        </div>
      ) : (
        <>
          <div className="grid gap-3 sm:grid-cols-2">
            <div><Label className="text-xs">جوال حساب الشركة (المالك)</Label><Input dir="ltr" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="05xxxxxxxx" className="mt-1" data-testid="pf-link-phone" /></div>
            <div><Label className="text-xs">كلمة مرور حساب الشركة</Label><Input type="password" dir="ltr" value={f.pw} onChange={(e) => setF({ ...f, pw: e.target.value })} className="mt-1" data-testid="pf-link-pw" /></div>
          </div>
          <Button onClick={link} disabled={busy || !f.phone || !f.pw} className="mt-4 gap-1.5 rounded-xl" data-testid="pf-link-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />} ربط الحساب</Button>
        </>
      )}
    </div>
  );
};

export const PfPasswordCard = () => {
  const [f, setF] = useState({ cur: "", n1: "", n2: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!/^\d{6}$/.test(f.n1)) { toast.error("الرمز السري يجب أن يكون 6 أرقام بالضبط"); return; }
    if (f.n1 !== f.n2) { toast.error("تأكيد كلمة المرور غير مطابق"); return; }
    setBusy(true);
    try { await api.pfPassword(f.cur, f.n1); toast.success("تم تغيير كلمة المرور"); setF({ cur: "", n1: "", n2: "" }); }
    catch (e) { toast.error(errText(e, "تعذّر التغيير")); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl bg-white p-5 sm:p-6" data-testid="pf-password-card">
      <p className="mb-4 flex items-center gap-2 font-heading font-bold text-slate-900"><KeyRound className="h-4 w-4 text-amber-500" /> كلمة مرور حساب المنصة</p>
      <div className="grid gap-3 sm:grid-cols-3">
        {[["cur", "الحالية"], ["n1", "الجديدة"], ["n2", "تأكيد الجديدة"]].map(([k, l]) => (
          <div key={k}><Label className="text-xs">{l}</Label><Input type="password" pin={k !== "cur"} dir="ltr" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1" data-testid={`pf-pw-${k}`} /></div>))}
      </div>
      <Button onClick={save} disabled={busy || !f.cur} className="mt-4 gap-1.5 rounded-xl" data-testid="pf-pw-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ كلمة المرور</Button>
    </div>
  );
};
